import { render, staticRenderFns } from "./claimed-work.vue?vue&type=template&id=628698de&scoped=true&"
import script from "./claimed-work.vue?vue&type=script&lang=ts&"
export * from "./claimed-work.vue?vue&type=script&lang=ts&"
import style0 from "./claimed-work.vue?vue&type=style&index=0&id=628698de&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628698de",
  null
  
)

export default component.exports